import { useState } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import Swiper from "react-id-swiper";
import SimpleImageSlider from "react-simple-image-slider";
import useWindowDimensions from "../WindowSize";
import Slider from "react-slick";
import { FaAngleRight } from "react-icons/fa";
import ComingSoon from "../common/ComingSoon";
import Image from "next/image"
import { useRouter } from "next/router";

const Why = () => {
  const { height, width } = useWindowDimensions();
  const [show, setShow] = useState(false);
  const router = useRouter();

  const images = [
    { url: "/assets/why/Caraousal-1.webp" },
    { url: "/assets/why/Caraousal-2.webp" },
    { url: "/assets/why/Caraousal-3.webp" },
  ];
  const [swiper, setSwiper] = useState(null);

  const params = {
    loop: false,
    slidesPerView: 1,
    grabCursor: true,
    centeredSlides: true,
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div
      style={{
        marginBottom: "50px",
        paddingLeft: "30px",
        paddingRight: "30px",
      }}
      id="why"
    >
      <Container>
        {/* <Row
          className="justify-content-center text-center"
          style={{ marginBottom: "2%" }}
        >
          <Col lg={12} className="px-5">
            <div className="title-anim">
              <div className="header-all">Why Choose Open Bonnet?</div>
            </div>
            <p className="subHead-all">
              Quality, Convenience & Trust Is Guaranteed By All Listed Auto
              Repair Workshops
            </p>
          </Col>
        </Row> */}
        <Row>
          <Col
            lg={4}
            md={4}
            sm={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="mb-2"
          >
            <div className="card-why">
              <div
                className="w-100 h-100 position-relative"
                style={{ cursor: "pointer" }}
                onClick={() => router.push("/super-car")}
              >
                <div
                  style={{
                    // position: "absolute",
                    // left: 0,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 10,
                    position: "relative",
                    overflow: "hidden"
                  }}
                >
                  <Image
                    src={"/assets/cars/super-car.webp"}
                    alt={"Super Car"}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                {/* <img
                  src="/assets/cars/super-car.webp"
                  style={{
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 10,
                    // margin: 10,
                  }}
                /> */}
                <div className="title">
                  <h2 className="text-white">Super Cars</h2>
                  <p className="text-white mb-0">
                    Your premium car needs specialized care & trusted advice
                  </p>
                  <p className="text-white mb-0">
                    View More <FaAngleRight />
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <ComingSoon show={show} handleClose={() => setShow(false)} />
          <Col
            lg={4}
            md={4}
            sm={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="mb-2"
          >
            <div className="card-why" style={{ justifyContent: "flex-start" }}>
              <div
                style={{ margin: "5px", borderRadius: "20px", width: "100%" }}
              >
                <SimpleImageSlider
                  width={"90%"}
                  height={220}
                  images={images}
                  style={{
                    // borderRadius: "20px",
                    width: "100%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    background: "#fff",
                  }}
                  showNavs={false}
                  showBullets={true}
                  autoPlay={true}
                />
              </div>
              <h3 className="mt-2">Why Open Bonnet?</h3>
              <ul
                className="why-text m-3 px-3"
                style={{
                  textAlign: "left",
                  color: "rgba(0,0,0,0.6)",
                  fontWeight: "500",
                  fontSize: "15px",
                  listStyle: "initial",
                }}
              >
                <li className="my-1" style={{ marginBottom: "2px" }}><img width={20} style={{ marginBottom: "5px" }} src="/assets/correctimage-removebg-preview.webp" /> Services backed by OB Assure</li>
                <li className="my-1" style={{ marginBottom: "2px" }}><img width={20} style={{ marginBottom: "5px" }} src="/assets/correctimage-removebg-preview.webp" /> Earn 1% OB CashPoints on all jobs</li>
                <li className="my-1" style={{ marginBottom: "2px" }}><img width={20} style={{ marginBottom: "5px" }} src="/assets/correctimage-removebg-preview.webp" /> Download OB Service History</li>
                <li className="my-1" style={{ marginBottom: "2px" }}><img width={20} style={{ marginBottom: "5px" }} src="/assets/correctimage-removebg-preview.webp" /> Recommend & earn 100 CashPoints</li>
                <li className="my-1" style={{ marginBottom: "2px" }}><img width={20} style={{ marginBottom: "5px" }} src="/assets/correctimage-removebg-preview.webp" /> All your needs gathered in one place</li>
                <li className="my-1" style={{ marginBottom: "2px" }}><img width={20} style={{ marginBottom: "5px" }} src="/assets/correctimage-removebg-preview.webp" /> Best offers & discounts on real prices</li>
              </ul>
            </div>
          </Col>
          <Col
            lg={4}
            md={4}
            sm={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="mb-2"
          >
            <div className="card-why" style={{ justifyContent: "flex-start" }}>
              <img
                src="/assets/why3.webp"
                width={"95%"}
                alt="ob-image"
                style={{ margin: "5px", borderRadius: "20px" }}
              />
              <img
                src="/assets/images/level-up.webp"
                width="80%"
                className="mt-2"
                alt="level-up"
              />
              <h5 className="mt-3 text-black text-center font-weight-bold">
                Premium Annual Subscription
              </h5>
              <p className="text-black text-center">
                <span className="font-weight-bold">
                  Enhance Your OB Experience
                </span>
                <br />
                With Added Benefits <br />
                For <span className="font-weight-bold">AED 299</span> Only
              </p>
              <Slider
                className="w-100 d-flex align-items-center mb-4 home_card_slider"
                {...settings}
              >
                <div className="d-flex align-items-center w-100">
                  <img
                    alt="ob-image"
                    src="/assets/level-up/pickup.webp"
                    width={64}
                    className="mt-1"
                    style={{
                      padding: 8,
                    }}
                  />
                  <p className="m-0 text-blue ml-2" style={{ fontSize: 16 }}>
                    Free Pickup Drop On All Services
                  </p>
                </div>
                <div className="d-flex align-items-center w-100">
                  <img
                    alt="ob-image"
                    src="/assets/level-up/profit.webp"
                    width={64}
                    className="mt-1"
                    style={{
                      padding: 8,
                    }}
                  />
                  <p className="m-0 text-blue ml-2" style={{ fontSize: 16 }}>
                    Earn Double OB CashPoints
                  </p>
                </div>
                <div className="d-flex align-items-center w-100">
                  <img
                    alt="ob-image"
                    src="/assets/level-up/offer.webp"
                    width={64}
                    className="mt-1"
                    style={{
                      padding: 8,
                    }}
                  />
                  <p className="m-0 text-blue ml-2" style={{ fontSize: 16 }}>
                    Get Exclusive Offers
                  </p>
                </div>
                <div className="d-flex align-items-center w-100">
                  <img
                    alt="ob-image"
                    src="/assets/level-up/validity.webp"
                    width={64}
                    className="mt-1"
                    style={{
                      padding: 8,
                    }}
                  />
                  <p className="m-0 text-blue ml-2" style={{ fontSize: 16 }}>
                    12 Months Validity
                  </p>
                </div>
              </Slider>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Why;
